/* unplugin-vue-components disabled */
import BuilderInputs from 'components/builder/builder-inputs.vue'
import {makePulseSchema} from '../settings-defs'
import $global from 'stores/global'

export default {
  components: {BuilderInputs},
  provide() {
    return {store: this.pulse}
  },
  data() {
    return {
      pulse: {...$global.caps},
      schema: makePulseSchema(),
      saved_at: undefined,
      saving: false,
    }
  },
  methods: {
    async onUpdate() {
      this.saving = true
      try {
        // TODO: put_settings
        await $global.setAdminCaps(this.pulse)
        this.saved_at = Date.now()
      }
      catch (err) {
        $utils.toasts.error(err)
      }
      this.saving = false
    },
  },
}
